import { createFileRoute } from '@tanstack/react-router';

import { ErrorComponent } from '@/components/common/ErrorComponent';
import { useSetBreadcrumbs } from '@/components/layout/breadcrumbs';

import { TagsPage } from './-components/TagsPage';

function TagsRoute() {
  useSetBreadcrumbs([{ label: 'Workspace' }, { label: 'Tags' }]);
  return <TagsPage />;
}

export const Route = createFileRoute('/tags/')({
  component: TagsRoute,
  errorComponent: ErrorComponent,
});
